import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-9xl font-serif text-[#FFB4AB] animate-bounce">404</h1>
        <h2 className="text-4xl font-serif text-gray-800 mb-4">Page Not Found</h2>
        <p className="text-gray-600 text-lg mb-8 max-w-md mx-auto">
          Oops! It looks like this page has been eaten. Don't worry, we have plenty more fresh treats on our home page.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/" 
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#FFB4AB] hover:bg-[#FF9E95] text-[#2D2D2D] rounded-full transition-all shadow-md hover:shadow-lg"
          >
            <Home size={20} />
            Back to Home
          </Link>
          <Link 
            to="/menu" 
            className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-[#FFB4AB] text-[#2D2D2D] rounded-full hover:bg-[#FFB4AB]/10 transition-all"
          >
            <ArrowLeft size={20} />
            View Menu
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
